/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { DefaultTheme } from 'styled-components'

import { RadioStateObject } from 'ui/designSystem/RadioButton/types'
import { getHoverStyle } from 'ui/theme/getHoverStyle/getHoverStyle'

export const getBorderHoverStyle = ({
  theme,
  radioState,
  isHover,
  radioStateBorderColorError,
}: {
  theme: DefaultTheme
  radioState: RadioStateObject
  isHover?: boolean
  radioStateBorderColorError?: string
}) => {
  if (radioState.disabled) return {}
  return radioState.error && radioStateBorderColorError
    ? { borderColor: radioStateBorderColorError }
    : getHoverStyle({ borderColor: theme.designSystem.color.border.brandPrimaryHover, isHover })
}

export const getTextHoverStyle = ({
  theme,
  radioState,
  isHover,
  radioStateBorderColorError,
}: {
  theme: DefaultTheme
  radioState: RadioStateObject
  isHover?: boolean
  radioStateBorderColorError?: string
}) => {
  if (radioState.disabled) return {}
  return radioState.error && radioStateBorderColorError
    ? { borderColor: radioStateBorderColorError }
    : getHoverStyle({ textColor: theme.designSystem.color.text.brandPrimaryHover, isHover })
}
